module.exports = __webpack_public_path__ + "media/src/images/wordpress-947fb08ddadc305eedb4d00e9eb8aa4c.png";